import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux';
import App from './containers/app.jsx'

// Store
import configureStore from './redux/store.jsx';
const store = configureStore();

render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('content')
)


// WEBPACK FOOTER //
// ./App/index.jsx